import { useFinancialDataStore } from "../../../../../store/financial.store";
import { useBusinessStore } from "../../../../../store/buisness.store";

export const autoSaveNonCurrentAssets = async (
  previousValue,
  currentValue,
  setSavingStatus,
  route,
  router
) => {
  const financialDataStore = useFinancialDataStore();
  const businessStore = useBusinessStore();

  if (previousValue != currentValue) {
    setSavingStatus("loading", true);

    await financialDataStore.autoSaveNonCurrentAssets(
      route,
      async (business) => {
        if (!route.query?.business) {
          await businessStore.getBusiness(
            route.params.id,
            route.query.financial_year,
            route.query.financial_period
          );
          router.push({
            path: location.pathname,
            query: {
              ...route.query,
              business,
            },
          });
        }
        setTimeout(() => {
          setSavingStatus("loading", false);
          setSavingStatus("error", false);
          setSavingStatus("success", false);
        }, 3000);
      },
      setSavingStatus
    );
  }
};

export const autoSaveCurrentAssets = async (
  previousValue,
  currentValue,
  setSavingStatus,
  route,
  router
) => {
  const financialDataStore = useFinancialDataStore();
  const businessStore = useBusinessStore();

  if (previousValue != currentValue) {
    setSavingStatus("loading", true);
    await financialDataStore.autoSaveCurrent(
      route,
      async (business) => {
        if (!route.query?.business) {
          await businessStore.getBusiness(
            route.params.id,
            route.query.financial_year,
            route.query.financial_period
          );
          router.push({
            path: location.pathname,
            query: {
              ...route.query,
              business,
            },
          });
        }
        setTimeout(() => {
          setSavingStatus("loading", false);
          setSavingStatus("error", false);
          setSavingStatus("success", false);
        }, 3000);
      },
      setSavingStatus
    );
  }
};
